// extracted by mini-css-extract-plugin
export default {"skeletonWrapper":"PositionSkeletonList_skeletonWrapper__mv+at","skeletonInputWidth":"PositionSkeletonList_skeletonInputWidth__on+W5"};